import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "team-person" }
const _hoisted_2 = {
  class: "button button--mobile-no-full-width",
  type: "button"
}
const _hoisted_3 = { class: "button__text" }
const _hoisted_4 = { class: "team-person__presenter-container" }
const _hoisted_5 = { class: "team-person__presenter" }
const _hoisted_6 = { class: "team-person__selector" }
const _hoisted_7 = {
  key: 0,
  class: "team-person__overlay"
}

import { customError, customLog } from '../../../../../../javascripts/utils/log';
import { computed, onMounted, ref } from 'vue';
import TeamPresenter from '../../../../../organisms/team/views/__team-presenter/vue/team-presenter.vue';
import TeamSelector from '../../../../../molecules/team-selector/vue/team-selector.vue';
import PersonBubble from '../../../../../atoms/person-bubble/vue/person-bubble.vue';
import ResortBubble from '../../../../../molecules/resort-bubble/vue/resort-bubble.vue';
import PersonOverlay from '../../../../../molecules/person-overlay/vue/person-overlay.vue';


export default {
  __name: 'team-person-view',
  props: {
  backButtonText: {
    type: String,
    required: true,
    validator: (value) => value.length > 0,
  },
  selectedPerson: {
    type: Object,
    required: true,
  },
  relatedResorts: {
    type: Array,
    required: true,
    validator: (value) => value.length > 0,
  },
  teamSelector: {
    type: Object,
    required: true,
  },
},
  emits: {
  clickedBackButton: () => {
    customLog('[TeamPersonView]: clickedBackButton event emitted');
    return true;
  },
  updateSelectedResort: (id) => {
    if (id) {
      customLog(`[TeamPersonView]: updateSelectedResort event emitted with id ${id}`);
      return true;
    } else {
      customError('[TeamPersonView]: updateSelectedResort event must have an id');
      return false;
    }
  },
  updateSelectedPerson: (id) => {
    if (id) {
      customLog(`[TeamPersonView]: updateSelectedPerson event emitted with id ${id}`);
      return true;
    } else {
      customError('[TeamPersonView]: updateSelectedPerson event must have an id');
      return false;
    }
  },
},
  setup(__props, { emit: __emit }) {

const props = __props;

const showPersonOverlay = ref(false);

const emit = __emit;

const handleBackButtonClick = () => {
  customLog('[TeamPersonView]: clicked back button');
  emit('clickedBackButton');
}

const handleInnerComponentClicked = (id) => {
  customLog(`[TeamPersonView]: innerComponentClicked event received with id ${id}`);
  showPersonOverlay.value = true;
}

const handleOuterComponentClicked = (id) => {
  customLog(`[TeamPersonView]: outerComponentClicked event received with id ${id}`);
  emit('updateSelectedResort', id);
}

const personBubbleProps = computed(() => ({
  personId: props.selectedPerson.id,
  personImage: {
    src: props.selectedPerson.image.thumbnail,
    alt: props.selectedPerson.image.alt,
    height: 70,
    width: 70,
  }
}));

const resortBubblesProps = computed(() => props.relatedResorts.map((resort) => ({
  resortId: resort.id,
  resortName: resort.name,
  resortMemberCount: resort.memberCount,
  resortInfoText: resort.description,
  showMemberIndicator: true,
})));

const personOverlayProps = computed(() => ({
  personName: props.selectedPerson.name,
  personInfoText: props.selectedPerson.description,
  personImage: {
    src: props.selectedPerson.image.src,
    alt: props.selectedPerson.image.alt,
    height: 317,
    width: 372,
  },
  readMoreButton: {
    label: props.selectedPerson.readMoreButton.label,
    link: props.selectedPerson.readMoreButton.link,
  },
  resorts: props.selectedPerson.resorts.map((resort) => resort.name),
  socials: props.selectedPerson.socials.map((social) => ({
    icon: social.icon,
    link: social.link,
  }))
}))

// transition
const showPresenter = ref(false);

onMounted(() => {
  customLog('[TeamPersonView]: onMounted hook');
  showPresenter.value = true;
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "team-person__back-button",
      onClick: handleBackButtonClick
    }, [
      _createElementVNode("button", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("svg", {
          class: "icon icon--play button__icon",
          viewBox: "0 0 200 200",
          "aria-hidden": "true"
        }, [
          _createElementVNode("use", { "xlink:href": "#icon-arrow-left" })
        ], -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(props.backButtonText), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_Transition, { name: "presenter-fade" }, {
          default: _withCtx(() => [
            (showPresenter.value)
              ? (_openBlock(), _createBlock(TeamPresenter, {
                  key: 0,
                  innerComponent: PersonBubble,
                  outerComponent: ResortBubble,
                  "inner-component-props": personBubbleProps.value,
                  "outer-components-props": resortBubblesProps.value,
                  onInnerComponentClicked: handleInnerComponentClicked,
                  onOuterComponentClicked: handleOuterComponentClicked,
                  "inner-component-click-event-name": "personBubbleClicked",
                  "outer-component-click-event-name": "resortBubbleClicked"
                }, null, 8, ["inner-component-props", "outer-components-props"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(TeamSelector, {
        "has-full-width": true,
        "initial-person-id": __props.selectedPerson.id,
        message: __props.teamSelector.message,
        "default-option-resort": __props.teamSelector.defaultOptionResort,
        "default-option-person": __props.teamSelector.defaultOptionPerson,
        resorts: __props.teamSelector.resorts,
        persons: __props.teamSelector.persons,
        onUpdateSelectedResort: _cache[0] || (_cache[0] = $event => (_ctx.$emit('updateSelectedResort', $event))),
        onUpdateSelectedPerson: _cache[1] || (_cache[1] = $event => (_ctx.$emit('updateSelectedPerson', $event)))
      }, null, 8, ["initial-person-id", "message", "default-option-resort", "default-option-person", "resorts", "persons"])
    ]),
    _createVNode(_Transition, { name: "overlay-fade" }, {
      default: _withCtx(() => [
        (showPersonOverlay.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(PersonOverlay, {
                onCloseOverlay: _cache[2] || (_cache[2] = () => showPersonOverlay.value = false),
                "person-name": personOverlayProps.value.personName,
                "person-info-text": personOverlayProps.value.personInfoText,
                "person-image": personOverlayProps.value.personImage,
                "read-more-button": personOverlayProps.value.readMoreButton,
                resorts: personOverlayProps.value.resorts,
                socials: personOverlayProps.value.socials
              }, null, 8, ["person-name", "person-info-text", "person-image", "read-more-button", "resorts", "socials"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

}